import { useNavigate } from 'react-router-dom';

import type { AttentionItem } from '../attention';

export function DeficitAlert({ items }: { items: AttentionItem[] }) {
  const navigate = useNavigate();

  return (
    <div id="attention-block" className="dash-card">
      <div className="dash-section-label" style={{ color: 'var(--error)', marginBottom: 12 }}>
        Потребує уваги
      </div>

      {items.length === 0 ? (
        <div className="dash-attn-ok">
          <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--success)' }}>
            Наразі зауважень немає
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
            Сушіння йдуть за планом, складських залишків ЧЗ достатньо для поточних замовлень
          </div>
        </div>
      ) : (
        items.map((item) => (
          <div
            key={item.key}
            className={`dash-attn-row is-${item.tone}`}
            onClick={() => navigate(item.path)}
          >
            <div style={{ minWidth: 0 }}>
              <div className="dash-attn-name">{item.name}</div>
              <div className="dash-attn-sub">{item.sub}</div>
            </div>
            <span className="dash-attn-val">{item.value}</span>
          </div>
        ))
      )}
    </div>
  );
}
